import { i18n } from '@/commons/utils';

export function CreditCardToken(slider) {
  const card = this;

  card.init = params => {
    card.container = params.container;
    card.index = params.index;
    card.cvcInput = card.container.querySelector('.dkt-card-cvc');
    card.cvcButton = card.container.querySelector('.dkt-card-cvc-button');
    card.cvcContainer = card.container.querySelector('.dkt-card-cvc-container');

    const token = card.container.querySelector('.dkt-card');
    card.tokenId = token ? token.getAttribute('data-token-id') : null;

    card.isWallet = params.isWallet;
    const isFavorite = card.container.getAttribute('data-is-favorite') === 'true';
    card.state = {
      isFavorite,
      isSelected: isFavorite,
      isCvcTooltipVisible: false
    };

    card.events();
  };

  card.events = () => {
    if (card.cvcInput !== null) {
      card.cvcInput.addEventListener('change', card.isOk);
    }
    if (card.cvcButton !== null) {
      card.cvcButton.addEventListener('click', card.displayCvcTooltip);
    }

    if (card.isWallet === true) {
      if (card.container.querySelector('.dkt-gift-card-menu-item--favorite') !== null) {
        card.container.querySelector('.dkt-gift-card-menu-item--favorite').addEventListener('click', card.setAsFavorite);
      }
      if (card.container.querySelector('.dkt-gift-card-menu-item--delete') !== null) {
        card.container.querySelector('.dkt-gift-card-menu-item--delete').addEventListener('click', card.removeConfirmation);
      }
    } else {
      card.container.addEventListener('click', card.select);
    }

    card.container.addEventListener('transitionend', e => {
      if (e.target === card.container.querySelector('.dkt-card') && card.container.classList.contains('dkt-card-slider-item--deleted') === true) {
        slider.deleteItem(card.index);
      }
    });

    document.addEventListener('unSelectAllCreditCards', card.unselect);
  };

  card.select = () => {
    if (card.state.isSelected === false) {
      slider.displayCard(card);
      document.dispatchEvent(new CustomEvent('unSelectAllCreditCards'));
      if (card.isWallet === true) {
        card.container.setAttribute('data-is-favorite', 'true');
        card.container.classList.add('dkt-card-slider-item--favorite');
        card.state.isFavorite = true;
      } else {
        card.container.classList.add('dkt-card-slider-item--selected');
        if (card.cvcContainer !== null) {
          card.cvcInput.value = '';
        }
      }
      card.state.isSelected = true;
    }
  };

  card.unselect = () => {
    if (card.isWallet === true) {
      card.container.classList.remove('dkt-card-slider-item--favorite');
      card.container.setAttribute('data-is-favorite', 'false');
      card.state.isFavorite = false;
    } else {
      card.container.classList.remove('dkt-card-slider-item--selected');
    }
    card.state.isSelected = false;
    card.changeDisplayError(false);
  };

  card.isOk = () => {
    if (card.cvcContainer !== null) {
      card.cvc = card.cvcInput.value;
      const isCvcOk = ((card.cvc.length === 3 || card.cvc.length === 4) && card.cvc > 0);

      card.state.hasError = !isCvcOk;
      card.changeDisplayError(!isCvcOk);
      return isCvcOk;
    }
    return true;
  };

  card.changeDisplayError = isErrorDisplayed => {
    if (isErrorDisplayed === true) {
      card.container.classList.add('dkt-card-slider-item--error');
      card.cvcInput.focus();
    } else {
      card.container.classList.remove('dkt-card-slider-item--error');
    }
  };

  card.displayCvcTooltip = () => {
    if (card.state.isCvcTooltipVisible === false) {
      card.cvcContainer.classList.add('dkt-card-cvc-container--open');
    } else {
      card.cvcContainer.classList.remove('dkt-card-cvc-container--open');
    }
    card.state.isCvcTooltipVisible = !card.state.isCvcTooltipVisible;
  };

  card.removeConfirmation = () => {
    const popin = document.createElement('div');
    popin.className = 'dkt-card-popin';
    popin.innerHTML = `<span class="dkt-card-popin-title">${i18n('myaccount.myMeanOfPayment.deleteConfirmation')}</span>
      <div class="dkt-card-popin-buttons">
        <button class="dkt-card-popin-cancel">${i18n('myaccount.myMeanOfPayment.no')}</button>
        <button class="dkt-card-popin-validate">${i18n('myaccount.myMeanOfPayment.yes')}</button>
      </div>`;
    card.container.appendChild(popin);
    popin.querySelector('.dkt-card-popin-cancel').addEventListener('click', () => {
      popin.remove();
    });
    popin.querySelector('.dkt-card-popin-validate').addEventListener('click', () => {
      card.container.classList.add('dkt-card-slider-item--deleted');
      card.removeCard();
    });
  };

  card.setAsFavorite = () => {
    card.select();

    const params = {
      tokenId: card.tokenId
    };

    window.getAjaxHandler()
      .withUrl('rest/model/com/decathlon/cube/commerce/payment/WalletActor/updateFavoriteToken')
      .withParameters(params)
      .call();
  };

  card.removeCard = () => {
    const params = {
      tokenId: card.tokenId
    };

    window.getAjaxHandler()
      .withUrl('rest/model/com/decathlon/cube/commerce/payment/WalletActor/removeToken')
      .withParameters(params)
      .call();
  };
}



// WEBPACK FOOTER //
// ./src/checkout/payment/payment-creditcard-token.js